/* eslint-env browser */
import { Component, OnInit,  OnDestroy, ChangeDetectorRef, ComponentRef, signal, DestroyRef, inject, ViewContainerRef, input, output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NavigationExtras, Router } from '@angular/router';
import { TvangebotimagevideoComponent } from '@app/components/modals/tvangebotimagevideo/tvangebotimagevideo.component';
import { Customer } from '@app/models/customers/Customer';
import { Partner } from '@app/models/partner/IPartner';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { AuthService } from '@app/services/auth.service';
import { EncryptionService } from '@app/services/encyption.service';
import { Subscription } from 'rxjs';
import { CommentComponent } from '../comment/comment.component';
import moment from 'moment';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RatehawkService } from '@app/services/ratehawke.servie';
import { AcvisService } from '@app/services/acvis.service';
import { RatehawkDetailComponent } from '../offerpackdetailmodal/ratehawk-detail/ratehawk-detail.component';

@Component({
    selector: 'clever-offerpackratehawkcard',
    templateUrl: './offerpackratehawkcard.component.html',
    styleUrls: ['./offerpackratehawkcard.component.scss'],
    standalone: false
})
export class OfferpackratehawkcardComponent implements OnInit, OnDestroy {
    readonly offerid = input<string>(undefined);
    readonly mitEmail = input<string>(undefined);
    readonly index = input<number>(undefined);
    readonly reference = input<string>(undefined);
    readonly mitName = input<string>(undefined);
    readonly mitTel = input<string>(undefined);
    readonly packid = input<string>(undefined);
    readonly online = input<string>(undefined);
    readonly removeFromList = output<string>();
    readonly changeindex = output<{
    dragedindex: number;
    dropindex: number;
}>();

    currentCustomer: Customer;
    currentpartner: Partner;
    component: ComponentRef<any>;

    showDetail: boolean = false;
    showImmages: boolean = true;
    endtDate: string = '';

    sendRegSub: Subscription;
    sendBook: Subscription;
    sendBack: Subscription;
    images: any[];
    categoryAr = [];
    datas;
    myhotel: any;
    myprice: any;
    destroyRef = inject(DestroyRef);
    dauer = signal<string>('0');
    adults = signal<number>(0);
    child = signal<number>(0);
    desktopTemplate = signal<string>('lg');
    constructor(
        private auth: AuthService,
        private authguad: AuthGuardService,
        private dialog: MatDialog,
        private viewContainerRef: ViewContainerRef,
        private encservice: EncryptionService,
        private router: Router,
        private cdr: ChangeDetectorRef,
        protected acvisService: AcvisService,
        protected ratehawkService: RatehawkService,
        protected mediaObserver: BreakpointObserver,
    ) {
    }

    
    ngOnDestroy(): void {
        this.sendRegSub?.unsubscribe();
        this.sendBack?.unsubscribe();
    }

    ngOnInit(): void {
        this.initMedia();
        this.initCustomer();
        this.initPartner();
    }

    async dragStart(ev: DragEvent, index: number) {
        ev.stopPropagation();
        ev.dataTransfer.effectAllowed = 'move';
        ev.dataTransfer.setData('dragedindex', index + '');
    };

    async dragOver(event: DragEvent) {
        event.preventDefault();
    }

    async dropp(ev: DragEvent) {
        ev.stopPropagation();
        const dragedindex = ev.dataTransfer.getData('dragedindex')
        const index = this.index();
        if (Number(dragedindex) > 0 && Number(dragedindex) !== index) {
            this.changeindex.emit({ dragedindex: Number(dragedindex) - 1, dropindex: index - 1 });
        }
    }

    async initCustomer() {
        this.auth.auth$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((customer: Customer) => {
            this.currentCustomer = customer;
        });
    }

    async initPartner() {
        this.authguad.getPartner$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(partner => {
            this.currentpartner = partner;
            if (this.currentpartner?.partnerid?.length > 0) {
                this.initData();
            }
        });
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate.set('xs');
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate.set('sm');
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate.set('lg');
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate.set('xl');
        }
        this.cdr.detectChanges();
    }

    async initData() {
        this.ratehawkService.request({ offerid: this.offerid() }, 'getAngebotratehawk').pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(ang => {
            // console.log(ang);
            if (ang?.hotelid?.length > 0) {
                this.datas = ang;
                this.initTravelers();
                this.dauer.set(moment.duration(moment(this.datas.filter.checkout)
                    .diff(moment(this.datas.filter.checkin))).asDays() + '');
                this.getHotel(ang.hotelid);
                this.myprice = this.datas.prc;
            }
        });
    }

    async initTravelers() {
        let ad = 0;
        let child = 0;
        for (let i = 0; i < this.datas.filter?.guests?.length; i++) {
            ad += this.datas.filter.guests[i].adults;
            child += this.datas.filter.guests[i].children?.length;
        }

        this.adults.set(ad);
        this.child.set(child);
    }

    async getHotel(id) {
        this.acvisService.request({ id: id }, 'hotelbyidratehawk').pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(hotel => {
            // console.log(hotel)
            this.myhotel = hotel;
            this.cdr.detectChanges();
            this.initImages();
        });
    }

    async initImages() {
        this.images = [];
        this.cdr.detectChanges();
        for (let i = 0; i < this.myhotel.images?.length; i++) {
            this.images.push(this.myhotel.images[i].replace('{size}', '640x400'));

        }

        if (this.images?.length > 0 && this.datas.firstBilder?.length > 0) {
            const pos = this.images.indexOf(this.datas.firstBilder);
            this.images = this.changeBilderPos(this.images, pos);
        }

        const catg = Number(String(this.myhotel?.star_rating).replace(/,/g, '.').replace(/\+/g, ''));
        for (let i = 0; i < Math.floor(catg); i++) {
            this.categoryAr.push(1);
        }
        if (catg > Math.floor(catg)) {
            this.categoryAr.push(0.5);
        }
       this.cdr.detectChanges();
    }

    async removeFromListF() {
        this.removeFromList.emit(this.offerid());
    }

    async gotoBuchen() {
        const navigationExtras: NavigationExtras = {
            queryParams: { params: this.encservice.encrypt({ offerid: this.datas.offerid }) }
        };
        const url = this.router.serializeUrl(
            this.router.createUrlTree(['hotelweltweitbooking'], navigationExtras)
        );
        const link = document.createElement('a');
        link.target = '_blank';
        link.href = url;
        link.setAttribute('visibility', 'hidden');
        link.click();
    }

    async gotoOffers() {
        const navigationExtras: NavigationExtras = {
            queryParams: { params: this.encservice.encrypt(this.datas.filter) }
        };
        const url = this.router.serializeUrl(
            this.router.createUrlTree([this.currentpartner.partnerid, 'hotelweltweit'], navigationExtras)
        );
        const link = document.createElement('a');
        link.target = '_blank';
        link.href = url;
        link.setAttribute('visibility', 'hidden');
        link.click();
    }

    openImageModal(ev) {
        const target = {
            disableClose: true,
            panelClass: ['full-screen-modal'],
            data: {
                hotel: null,
                images: this.images,
                videos: [],
                current: ev,
                to800: false,
                desktopTemplate: this.desktopTemplate,
                showSave: true
            }
        }
        const resf = this.dialog.open(TvangebotimagevideoComponent, target);
        resf.afterClosed().pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((pos) => {
            if (pos !== this.datas.firstBilderPos) {
                this.datas.firstBilderPos = pos;
                this.saveImagesList();
            }
        });
    }

    openDetail() {
        if (this.component) {
            this.component.destroy();
        }
        this.sendRegSub?.unsubscribe();
        this.component = this.viewContainerRef.createComponent(RatehawkDetailComponent);
        this.component.instance.datas = this.datas;
        this.component.instance.hotel = this.myhotel;
        this.sendRegSub = this.component.instance.sendAlt.subscribe((ev) => {
            if (ev) {
                this.gotoOffers();
            }
        });
        this.sendBook = this.component.instance.sendBook.subscribe((ev) => {
            if (ev) {
                this.gotoBuchen();
            }
        });
        this.showDetail = true;
        this.cdr.detectChanges();
    }

    saveImagesList() {
        const target = {
            offerid: this.offerid(),
            firstBilder: this.images[this.datas.firstBilderPos],
        };
        this.ratehawkService.request(target, 'updateImageList').pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((res) => {
            if (res?.error) {
                // console.log(res);
            } else {
                if (this.images) {
                    this.images = this.changeBilderPos(this.images, this.datas.firstBilderPos);
                    this.showImmages = false;
                    this.datas.firstBilderPos = 0;
                    this.cdr.detectChanges();
                    setTimeout(() => {
                        this.showImmages = true;
                        this.cdr.detectChanges();
                    });
                }
            }
            this.cdr.detectChanges();
        });
    }

    changeBilderPos(targetArray, pos): string[] {
        if (targetArray?.length > 0) {
            targetArray.splice(0, 0, targetArray[pos]);
            targetArray.splice(pos + 1, 1);
        }
        return targetArray;
    }

    closeModal(ev) {
        if (ev) {
            this.showDetail = false;
            this.cdr.detectChanges();
        }
    }

    async openSetComment() {
        let target = {} as MatDialogConfig;
        if (this.desktopTemplate() !== 'xs' && this.desktopTemplate() !== 'sm') {
            target = {
                width: '600px',
                data: {
                    title: 'Angebot Nr.' + this.index(),
                    message: this.datas.extracomment
                },
                autoFocus: false
            };
        } else {
            target = {
                width: '100%',
                height: '100%',
                maxWidth: '100%',
                // panelClass: 'customModal',
                data: {
                    title: 'Angebot Nr.' + this.index(),
                    message: this.datas.extracomment
                },
                autoFocus: false
            }
        }
        const resf = this.dialog.open(CommentComponent, target);
        resf.afterClosed().pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((data) => {
            if (data) {
                this.datas.extracomment = data?.message;
                this.saveComment(this.datas.extracomment);
            }
        });
    }

    saveComment(extracomment) {
        const target = {
            offerid: this.offerid(),
            extracomment: extracomment,
            partnerid: this.currentpartner?.partnerid
        };
        this.ratehawkService.request(target, 'saveComment').pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((res) => {
            if (res?.error) {
                console.log(res);
            }
        });
    }
}
